import React, { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import Box from '@material-ui/core/Box'
import CircularProgress from '@material-ui/core/CircularProgress'
import UserService from '../../services/User/index'
import { urls } from '../../urls'

const APP_HOME = `/${urls.app.index}/${urls.app.main.electronicBill.form}`

/** Redirects the app root to the electronic bill form or login after checking session. */
export default function RootRedirect () {
  const [target, setTarget] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false

    async function resolveTarget () {
      const userService = new UserService()
      const session = await userService.tryRestoreSession()
      if (cancelled) {
        return
      }
      if (session) {
        setTarget(APP_HOME)
      } else {
        setTarget(urls.page.login)
      }
    }

    resolveTarget()

    return () => {
      cancelled = true
    }
  }, [])

  if (target === null) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    )
  }

  return <Navigate to={target} replace />
}
